/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBETHNICITY = {
    Black: 'B',
    Unknown: 'U',
    Coloured: 'C',
    Asian: 'A',
    White: 'W'
} as const;
export type GHUBETHNICITY = typeof GHUBETHNICITY[keyof typeof GHUBETHNICITY];


export function GHUBETHNICITYFromJSON(json: any): GHUBETHNICITY {
    return GHUBETHNICITYFromJSONTyped(json, false);
}

export function GHUBETHNICITYFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBETHNICITY {
    return json as GHUBETHNICITY;
}

export function GHUBETHNICITYToJSON(value?: GHUBETHNICITY | null): any {
    return value as any;
}

